import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Download, Loader2, FileCheck2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { api, eur, fmtDate, formatApiError, downloadFile } from "../lib/api";

export default function PublicInvoice() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get(`/public/invoices/${token}`).then((r) => setD(r.data)).catch((e) => setError(formatApiError(e)));
  }, [token]);

  const download = async () => {
    setBusy(true);
    try {
      await downloadFile(`/public/invoices/${token}/facturx`, {}, `${d.invoice.number}-factur-x.pdf`);
    } catch (e) {
      toast.error("Téléchargement impossible");
    } finally {
      setBusy(false);
    }
  };

  if (error) return <div className="flex min-h-screen items-center justify-center p-6 text-slate-600" data-testid="public-invoice-error">{error}</div>;
  if (!d) return <div className="flex min-h-screen items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-[#1559d6]" /></div>;
  const { invoice: inv, company } = d;
  return (
    <div className="min-h-screen bg-slate-100 px-4 py-10">
      <div className="mx-auto max-w-2xl rounded-2xl bg-white p-6 shadow-sm sm:p-10" data-testid="public-invoice">
        <p className="text-xs font-semibold uppercase tracking-widest text-teal-600">{company.name}</p>
        <h1 className="mt-1 text-2xl font-bold text-slate-900">Facture {inv.number}</h1>
        <p className="mt-1 text-sm text-slate-500">Émise le {fmtDate(inv.issued_date)} · échéance {fmtDate(inv.due_date)} · {inv.client_name}</p>
        <div className="mt-6 space-y-1.5 text-sm">
          {inv.lines.map((l) => <div key={l.label} className="flex justify-between gap-3"><span className="text-slate-600">{l.label}</span><span>{eur(l.amount)}</span></div>)}
          <div className="flex justify-between border-t pt-2"><span>Total HT</span><span>{eur(inv.total_ht)}</span></div>
          <div className="flex justify-between"><span>TVA 20 %</span><span>{eur(inv.tva)}</span></div>
          <div className="flex justify-between text-base font-bold text-[#0b2c6b]"><span>Total TTC</span><span data-testid="public-invoice-total">{eur(inv.total_ttc)}</span></div>
          <div className="flex justify-between text-slate-600"><span>Déjà réglé</span><span>{eur(inv.amount_paid)}</span></div>
          <div className="flex justify-between font-semibold"><span>Reste à payer</span><span>{eur(inv.total_ttc - inv.amount_paid)}</span></div>
        </div>
        <Button data-testid="public-invoice-download" disabled={busy} onClick={download} className="mt-8 w-full rounded-full bg-[#0b2c6b] py-6 text-base hover:bg-[#1559d6]">
          {busy ? <Loader2 className="mr-2 h-5 w-5 animate-spin" /> : <Download className="mr-2 h-5 w-5" />}Télécharger la facture (Factur-X PDF)
        </Button>
        <p className="mt-4 flex items-center gap-2 text-xs text-slate-500"><FileCheck2 className="h-4 w-4 text-teal-600" />Facture électronique conforme EN 16931 : PDF lisible avec données XML intégrées, importable dans votre logiciel comptable.</p>
        <p className="mt-6 text-xs text-slate-400">{company.address} {company.postal_code} {company.city} {company.siret && `· SIRET ${company.siret}`} {company.email && `· ${company.email}`}</p>
      </div>
      <p className="mt-6 text-center text-xs text-slate-400">Propulsé par Logidem</p>
    </div>
  );
}
